<main class="season-status-section">
  @if (tvDetails?.next_episode_to_air) {
  <section class="season-status-container">
    <div class="header">
      <div class="header-title-group">
        <span class="header-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="5 3 19 12 5 21 5 3"></polygon>
          </svg>
        </span>
        <h2>Current Season</h2>
      </div>
    </div>
    <div class="season-status-card-container">
      <div class="backdrop-image-container" id="backdropContainer">
        <img *ngIf="tvDetails" #backdropImage class="movie-backdrop-image"
          [src]="backendUrl + '/proxy?url=https://image.tmdb.org/t/p/original/' + (lastSeason?.poster_path || tvDetails?.poster_path)"
          id="backdropImage" (error)="onImageError($event)" alt="" crossorigin="anonymous">
      </div>
      <div class="image-overlay"></div>
      <div class="season-status-card">
        <div class="image-wrapper">
          <img *ngIf="tvDetails" class="movie-image"
            [src]="backendUrl + '/proxy?url=https://image.tmdb.org/t/p/original/' + (lastSeason?.poster_path || tvDetails?.poster_path)"
            (error)="onImageError($event)" [alt]="lastSeason?.name || 'Season Poster'" crossorigin="anonymous">
        </div>
        <div class="season-status-info">
          <h1 class="season-title">{{ lastSeason?.name }}</h1>
          <div class="movie-metadata">
            <span class="movie-year" *ngIf="lastSeason?.release_date || lastSeason?.air_date">{{ lastSeason?.release_date || lastSeason?.air_date | slice:0:4 }}</span>
            <span class="movie-genre" *ngIf="lastSeason?.episode_count">
              {{ lastSeason?.episode_count }} Episodes
            </span>
          </div>
          <p class="movie-overview" *ngIf="lastSeason?.overview">
            {{ lastSeason?.overview }}
          </p>
          <div class="movie-previous" *ngIf="tvDetails?.next_episode_to_air?.name">
            <a class="season-cta-btn"
              [routerLink]="getSeasonRoute(lastSeason?.season_number)">
              <span>Next: {{ tvDetails?.next_episode_to_air?.name }}</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  } @else {
  <section class="season-status-container">
    <div class="header">
      <div class="header-title-group">
        <span class="header-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="5 3 19 12 5 21 5 3"></polygon>
          </svg>
        </span>
        <h2>Last Season</h2>
      </div>
    </div>
    <div class="season-status-card-container">
      <div class="backdrop-image-container" id="backdropContainer">
        <img *ngIf="tvDetails" #backdropImage class="movie-backdrop-image"
          [src]="backendUrl + '/proxy?url=https://image.tmdb.org/t/p/original/' + (lastSeason?.poster_path || tvDetails?.poster_path)"
          id="backdropImage" (error)="onImageError($event)" alt="" crossorigin="anonymous">
      </div>
      <div class="image-overlay"></div>
      <div class="season-status-card">
        <div class="image-wrapper">
          <a [routerLink]="getSeasonRoute(lastSeason?.season_number)">
            <img *ngIf="tvDetails" class="movie-image"
              [src]="backendUrl + '/proxy?url=https://image.tmdb.org/t/p/original/' + (lastSeason?.poster_path || tvDetails?.poster_path)"
              (error)="onImageError($event)" [alt]="lastSeason?.name || 'Season Poster'" crossorigin="anonymous">
          </a>
        </div>
        <div class="season-status-info">
          <h1 class="season-title">
            <a [routerLink]="getSeasonRoute(lastSeason?.season_number)" style="color: inherit; text-decoration: none;">
              {{ lastSeason?.name }}
            </a>
          </h1>
          <div class="movie-metadata">
            <span class="movie-year" *ngIf="lastSeason?.release_date || lastSeason?.air_date">{{ lastSeason?.release_date || lastSeason?.air_date | slice:0:4 }}</span>
            <span class="movie-genre" *ngIf="lastSeason?.episode_count">
              {{ lastSeason?.episode_count }} Episodes
            </span>
          </div>
          <p class="movie-overview" *ngIf="lastSeason?.overview">
            {{ lastSeason?.overview }}
          </p>
          <div class="movie-previous" *ngIf="tvDetails?.last_episode_to_air?.name">
            <a class="season-cta-btn"
              [routerLink]="getSeasonRoute(lastSeason?.season_number)">
              <span>Latest: {{ tvDetails?.last_episode_to_air?.name }}</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  }
</main>
